import React from 'react';

const DashboardCheckInCard = ({ isActive, isCheckedIn, isLoading, streak, onCheckIn, t }) => {
  return (
    <section
      className={`t-rounded-[14px] t-border t-border-g200 t-bg-white t-p-6 ${
        isActive ? '' : 't-pointer-events-none t-opacity-40'
      }`}
    >
      <p className="t-m-0 t-text-lg t-font-extrabold t-text-navy">{t('Dashboard_CheckIn_Title')}</p>
      <p className="t-m-0 t-mt-1 t-text-sm t-text-teal-muted">
        {t('Dashboard_CheckIn_Body')}
      </p>
      <div className="t-mt-6 t-flex t-flex-col t-gap-4 sm:t-flex-row sm:t-items-center sm:t-justify-between">
        <div className="t-flex t-items-center t-gap-3">
          <span className="t-text-2xl" aria-hidden="true">
            🔥
          </span>
          <div>
            <p className="t-m-0 t-text-2xl t-font-extrabold t-leading-none t-text-navy">{streak}</p>
            <p className="t-m-0 t-mt-1 t-text-xs t-text-teal-muted">{t('Dashboard_CheckIn_Streak')}</p>
          </div>
        </div>
        {isCheckedIn ? (
          <span className="t-inline-flex t-w-fit t-items-center t-gap-1 t-rounded-full t-bg-teal-bg t-px-5 t-py-2 t-text-sm t-font-extrabold t-text-quiz-teal">
            ✓ {t('Dashboard_CheckedInToday')}
          </span>
        ) : (
          <button
            type="button"
            className="t-w-full t-rounded-full t-border-0 t-bg-quiz-teal t-px-5 t-py-2.5 t-text-sm t-font-extrabold t-text-white disabled:t-cursor-not-allowed disabled:t-opacity-70 sm:t-w-auto"
            disabled={!isActive || isLoading}
            onClick={onCheckIn}
          >
            {isLoading ? t('Dashboard_CheckingIn') : t('Dashboard_CheckIn_Cta')}
          </button>
        )}
      </div>
    </section>
  );
};

export default DashboardCheckInCard;
